<template>
  <div>
    <div class="line1">
      <div class="title">联系我们，专业顾问为您解答</div>
      <div class="tel"> <a class="" href="tel:18617131848">商务电话：18617131848</a></div>
      <div class="ques">
        <div class="ques-code">
          <img v-if="imgFlag==0"  class="footer-item-public-img" src="@/assets/image/index/wx-public.jpg">
          <img v-else class="footer-item-public-img" :src="img">
          <div id="wl-qrcode5"></div>
        </div>

        立即咨询
      </div>
      <div class="qw">
        <img v-if="imgFlag==0"  class="footer-item-public-img" src="@/assets/image/index/wx-public.jpg">
        <img v-else class="footer-item-public-img" :src="img">
        <div id="wl-qrcode4"></div>
        <div class="footer-item-public-text">扫码添加客服企业微信</div>
      </div>
    </div>
    <div class="line2">
      <div class="top">
        <img style="width: 1.04rem;margin-right: 1rem" src="../../assets/image/index/logo.png">
        <div class="wl-info">
          <div class="item">
            <img class="item-icon" src="../../assets/image/footer-tel.png">
            <div class="item-desc">商务合作：<a class="" href="tel:18617131848">18617131848</a></div>
          </div>
          <div class="item">
            <img class="item-icon" src="../../assets/image/footer-tel.png">
            <div class="item-desc">网络问题：<a class="" href="tel:400-666-5780">400-666-5780</a></div>
          </div>
          <div class="item">
            <img class="item-icon" src="../../assets/image/footer-email.png">
            <div class="item-desc">电子邮箱：info@magicwifi.com.cn</div>
          </div>
        </div>
      </div>
      <div style="margin-top: 0.63rem;border-top:0.01rem solid #666666;height: 0.01rem;width: 100%;margin-bottom: 0.4rem"></div>
      <div class="bot">
        <div class="left">
          <div class="detail" @click="jump('about')">关于我们</div>
          <div class="detail" @click="jump('wireless')">无线校园</div>
          <div class="detail" @click="jump('smartCampus')">智慧校园</div>
          <div class="detail" @click="jump('product')">产品中心</div>
          <div class="detail" @click="jump('news')">新闻动态</div>
        </div>
        <div class="right">
          <a class="logo"  target="_blank" href="https://www.douyin.com/user/MS4wLjABAAAAYWk4xQ0nuBemj6FTvjB_92m_Lb4ogLliBVgA1yw6sked6fw1yjneTQNwTf3ahI11">
            <img class="logo-icon" src="../../assets/image/douyinLogo.png">
          </a>
          <div class="logo">
            <img src="../../assets/image/shiPinCode.png" class="code">
            <img class="logo-icon" src="../../assets/image/shipinhao.png">
          </div>
          <a class="logo" target="_blank" href="https://www.toutiao.com/c/user/token/MS4wLjABAAAAQ6NjODNngmQC1KIeOq6tLq9YQFuk99LL24pXZspklQkOqzbfLh6IffHXf0zAXq8X/?">
            <img class="logo-icon" src="../../assets/image/toutiaoLogo.png">
          </a>
          <div class="logo">
            <img src="../../assets/image/weCode.png" class="code">
            <img class="logo-icon" src="../../assets/image/weixinLogo.png">
          </div>
          <a class="logo" target="_blank" href="https://author.baidu.com/home?from=bjh_article&app_id=1794116290802466">
            <img class="logo-icon" src="../../assets/image/baijiahaoLogo.png">
          </a>
        </div>
      </div>
    </div>
    <div class="line3">
      <div>Copyright © 2005-2024 {{host}} 深圳市网联天下科技有限公司版权所有</div>
      <img src="../../assets/image/beian.png" style="width: 0.13rem;height: 0.14rem;margin: 0 0.05rem">
      <div>备案号：<a target="_blank" href="https://beian.miit.gov.cn/">粤ICP备 {{beian}}</a></div>
      <a style="margin-left: 0.2rem" target="_blank" :href="gonganLink">{{gongan}}</a>
    </div>

  </div>

</template>

<script>
export default {
  name: "FooterNew",
  data(){
    return{
      imgFlag:0,
      img:'',
      currentDomain:'',
      beian:'14021249号',
      host:'lemonwifi.cn',
      gongan:'',
      gonganLink:'',
    }
  },
  mounted() {
    console.log(window.location.host)
    if (window.location.host.includes('magicwifi.com.cn')) {
       this.beian='14021249号-2';
       this.host='magicwifi.com.cn'
        this.gongan='粤公网安备44030502002178号'
      this.gonganLink='https://beian.mps.gov.cn/#/query/webSearch?code=44030502002178'
    }else if(window.location.host.includes('lemonwifi.cn')){
      this.beian='14021249号-6';
      this.host='lemonwifi.cn'
      this.gongan='粤公网安备44030502009858号'
      this.gonganLink='https://beian.mps.gov.cn/#/query/webSearch?code=44030502009858'
    }else if(window.location.host.includes('lemonwifi.com.cn')){
      this.beian='14021249号-4';
      this.host='lemonwifi.com.cn'
      this.gongan='粤公网安备44030502002537号'
      this.gonganLink='https://beian.mps.gov.cn/#/query/webSearch?code=44030502002537'
    }

    // let host="https://lemonwifi.com.cn/index";
    // if (host.includes('magicwifi.com.cn')) {
    //   console.log('14021249号-2');
    // }else if(host.includes('lemonwifi.cn')){
    //   console.log('14021249号-6');
    // }else if(host.includes('lemonwifi.com.cn')){
    //   console.log('14021249号-4');
    // }
    this.initializeAndRun();
  },
  methods:{
    jump(url,query){
      if(url==='news'){
        this.$router.push({
          name: url,
          query
        });
      }else {
        this.$router.push({
          name: url,
        });
      }
    }  ,
    loadScript(src, id) {
      return new Promise((resolve, reject) => {
        if (document.getElementById(id)) {
          resolve(); // 如果脚本已经存在，直接resolve
          return;
        }

        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = src;
        script.id = id;

        script.onload = () => {
          resolve(); // 脚本加载成功，resolve
        };

        script.onerror = () => {
          reject(new Error(`Script load error for ${src}`)); // 脚本加载失败，reject
        };

        let s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(script, s);
      });
    },
    async initializeAndRun() {
      try {
        await this.loadScript(
          'https://material.weiling.cn/h5/willing-third-party-js/v1/qrcode-custom-comp-v1.min.js',
          'wlQRCS'
        );

        // 等待脚本加载完成后初始化
        wlQrcodeCustomComp.init({
          wl_id: 'wpW2WmDAAAsuSkpyHYrwjV4tnMu-Zjag', // [修改1：将wl_id粘贴至此]
        });

        // 初始化完成后要执行的代码
        console.log('wlQrcodeCustomComp initialized footer');
        // 在这里添加你需要执行的代码
        this.getCode();
      } catch (error) {
        console.error(error); // 处理加载脚本时的错误
      }
    },
    getCode(){
      wlQrcodeCustomComp.getQrCodeUrl(
        {
          wl_qrcode_id: "1801157726622015488", //  [修改1：将wl_qrcode_id粘贴至此]
        },
        (data) => {
          console.log(data); // data中包含二维码图片地址
          if(data.code==200){
            this.imgFlag=1;
            this.img=data.data.qr_code;
          }
        }
      );
    }
  }

}
</script>

<style scoped lang="scss">
img{
  max-width: max-content !important;
}
.line1{
  background-image: url("../../assets/image/footBg.png");
  background-position: center center;
  background-size: cover;
  padding: 0.57rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  .title{
    font-weight: 600;
    font-size: 0.32rem;
    color: #FFFFFF;
  }
  .tel{
    font-weight: 600;
    font-size: 0.2rem;
    color: #FFFFFF;
    margin: 0.27rem 0;
  }
  .ques{
    background:#FEF100 ;
    width: 3.7rem;
    height: 0.6rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    font-size: 0.2rem;
    color: #333333;
    border-radius: 0.04rem;
    cursor: pointer;
    position: relative;
    .ques-code{
      position: absolute;
      top:0.6rem;
      display: none;
    }

  }
  .ques:hover{
    .ques-code{
      display: block;
    }

  }
  .qw{
    position: absolute;
    top: 0.57rem;
    right: 2.14rem;
    text-align: center;
  }
}
.line2{
  background: #333333;
  padding: 0.67rem 1.8rem 0.4rem 1.8rem;
  .top{
    display: flex;
    .wl-info{
      flex: 1;
      display: flex;
      justify-content: space-between;
      .item{
        display: flex;
        align-items: center;
        .item-icon{
          width: 0.2245rem;
          margin-right: 0.1rem;
        }
        .item-desc{
          font-weight: 600;
          font-size: 0.23rem;
          color: #FFFFFF;
        }
      }
    }
  }
  .bot{
    display: flex;
    justify-content: space-between;
    .left{
      display: flex;
      .detail{
        margin-left: 0.8rem;
        font-weight: 500;
        font-size: 0.2rem;
        color: #FFFFFF;
        cursor: pointer;
      }
      .detail:first-child{
        margin-left: 0;
      }
    }
    .right{
      display: flex;
      .logo{
        margin-right: 0.2rem;
        cursor: pointer;
        position: relative;
        .logo-icon{
          width: 0.3998rem;
        }
        .code{
          position: absolute;
          width: 1.4rem;
          top: -1.85rem;
          right: -0.5rem;
          display: none;
        }
      }
      .logo:hover{
        .code{
          display: block;
        }
      }
      .logo:last-child{
        margin:0;
      }
    }
  }

}
.line3{
  background: #1E1E1E;
  padding: 0.24rem 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 400;
  font-size: 0.16rem;
  color: #FFFFFF;
}
.footer-item-public-img {
  width: 1.2rem;
  height: 1.2rem;
  margin-bottom: 0.11rem;
}

.footer-item-public-text {
  font-size: 0.14rem;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 0.20rem;
  color: #FFFFFF;
  opacity: 0.8;
}

</style>



// WEBPACK FOOTER //
// src/components/footerNew/FooterNew.vue